import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/data/site";

export default function CTASection() {
  return (
    <section className="relative bg-navy text-white py-24 sm:py-32 overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 hero-grid-overlay opacity-25" />
      <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-gold/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[520px] h-[520px] rounded-full bg-emerald-brand/15 blur-3xl" />

      <div className="container-x relative">
        <div className="max-w-4xl mx-auto text-center">
          <div className="overline text-gold">Ready to begin?</div>
          <h2 className="font-display font-extrabold text-4xl sm:text-6xl lg:text-7xl leading-[0.98] mt-6">
            Let&apos;s engineer<br />
            your next <span className="italic font-light text-gold">milestone</span>.
          </h2>
          <p className="mt-8 text-base sm:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
            Whether you&apos;re scoping a feasibility study, planning a hotel, or commissioning a public infrastructure project — start with a conversation.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-section-contact"
              className="inline-flex items-center gap-2 px-7 py-4 bg-gold text-navy font-semibold text-xs tracking-[0.2em] uppercase hover:bg-[#E8C45F] transition-colors"
            >
              Get in touch <ArrowRight size={16} />
            </Link>
            <a
              href={buildWhatsAppLink("Hello NEPHRC, I'd like to discuss a new project.")}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-section-whatsapp"
              className="inline-flex items-center gap-2 px-7 py-4 border border-white/30 text-white text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-navy transition-colors"
            >
              <MessageCircle size={14} /> Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
